"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// All of the variations on 'type' that a Grade Result may take.
exports.default = {
    // NCEA.
    NCEA_NOT_ACHIEVED_CREDITS: 'NCEA/notAchievedCredits',
    NCEA_ACHIEVED_CREDITS: 'NCEA/achievedCredits',
    NCEA_MERIT_CREDITS: 'NCEA/meritCredits',
    NCEA_EXCELLENCE_CREDITS: 'NCEA/excellenceCredits',
    NCEA_NOT_ACHIEVED_CREDITS_EXTERNAL: 'NCEA/notAchievedCreditsExternal',
    NCEA_ACHIEVED_CREDITS_EXTERNAL: 'NCEA/achievedCreditsExternal',
    NCEA_MERIT_CREDITS_EXTERNAL: 'NCEA/meritCreditsExternal',
    NCEA_EXCELLENCE_CREDITS_EXTERNAL: 'NCEA/excellenceCreditsExternal',
    NCEA_SUBJECT_ENDORSEMENT: 'NCEA/subjectEndorsement',
    NCEA_LEVEL_1_ENDORSEMENT: 'NCEA/level1Endorsement',
    NCEA_LEVEL_2_ENDORSEMENT: 'NCEA/level2Endorsement',
    NCEA_LEVEL_3_ENDORSEMENT: 'NCEA/level3Endorsement',
    NCEA_TOTAL_CREDITS: 'NCEA/totalCredits',
    NCEA_TOTAL_CREDITS_EXTERNAL: 'NCEA/totalCreditsExternal',
    // IB.
    IB_PREDICTED_GRADE: 'IB/predictedGrade',
    IB_ACHIEVED_GRADE: 'IB/achievedGrade',
    IB_TOK_PREDICTED_GRADE: 'IB/TOK/predictedGrade',
    IB_TOK_ACHIEVED_GRADE: 'IB/TOK/achievedGrade',
    IB_EE_PREDICTED_GRADE: 'IB/EE/predictedGrade',
    IB_EE_ACHIEVED_GRADE: 'IB/EE/achievedGrade',
    IB_CAS_PREDICTED_GRADE: 'IB/CAS/predictedGrade',
    IB_CAS_ACHIEVED_GRADE: 'IB/CAS/achievedGrade',
    IB_EE_TOK: 'IB/EE_TOK',
    IB_TOTAL_POINTS: 'IB/totalPoints',
    IB_RESULTS: 'IB/results',
    // CIE.
    CIE_SCHOOL_EXAM_PERCENTAGE: 'CIE/schoolExamPercentage',
    CIE_SCHOOL_EXAM_GRADE: 'CIE/schoolExamGrade',
    CIE_FINAL_EXAM_PERCENTAGE: 'CIE/finalExamPercentage',
    CIE_FINAL_EXAM_GRADE: 'CIE/finalExamGrade',
    CIE_AWARDS: 'CIE/awards',
    CIE_AGGREGATE_SCORE: 'CIE/aggregateScore',
    // HSC.
    HSC_EXAMINATION_MARK: 'HSC/examinationMark',
    HSC_ASSESSMENT_MARK: 'HSC/assessmentMark',
    HSC_MARK: 'HSC/mark',
    HSC_PERFORMANCE_BAND: 'HSC/performanceBand',
    HSC_ATAR: 'HSC/ATAR',
    // VCE.
    VCE_GA1: 'VCE/ga1',
    VCE_GA2: 'VCE/ga2',
    VCE_GA3: 'VCE/ga3',
    VCE_STUDY_SCORE: 'VCE/studyScore',
    VCE_SCALED_SCORE: 'VCE/scaledScore',
    VCE_AGGREGATE: 'VCE/aggregate',
    VCE_ATAR: 'VCE/ATAR',
    // NZQA.
    NZQA_AWARDS: 'NZQA/awards',
    NZQA_SCORE: 'NZQA/score',
    NZQA_OVERALL_AWARDS: 'NZQA/overallAwards',
    // SAT Reasoning.
    SAT_REASONING_READING_WRITING: 'SAT-REASONING/readingWriting',
    SAT_REASONING_MATH: 'SAT-REASONING/math',
    SAT_REASONING_ESSAY: 'SAT-REASONING/essay',
    SAT_REASONING_OVERALL_SCORE: 'SAT-REASONING/overallScore',
    // SAT Subject.
    SAT_SUBJECT_SCORE: 'SAT-SUBJECT/score',
    // ACT.
    ACT_MATH: 'ACT/math',
    ACT_SCIENCE: 'ACT/science',
    ACT_READING: 'ACT/reading',
    ACT_ENGLISH: 'ACT/english',
    ACT_WRITING: 'ACT/writing',
    ACT_OVERALL_SCORE: 'ACT/overallScore',
    // AP.
    AP_SCORE: 'AP/score',
    // IELTS
    IELTS_TEST_TYPE: 'IELTS/testType',
    IELTS_LISTENING: 'IELTS/listening',
    IELTS_READING: 'IELTS/reading',
    IELTS_WRITING: 'IELTS/writing',
    IELTS_SPEAKING: 'IELTS/speaking',
    IELTS_OVERALL: 'IELTS/overall',
    // TOEFL
    TOEFL_LISTENING: 'TOEFL/listening',
    TOEFL_READING: 'TOEFL/reading',
    TOEFL_WRITING: 'TOEFL/writing',
    TOEFL_SPEAKING: 'TOEFL/speaking',
    TOEFL_OVERALL: 'TOEFL/overall',
    // UCAT
    UCAT_VR_SCORE: 'UCAT/vrScore',
    UCAT_DM_SCORE: 'UCAT/dmScore',
    UCAT_QR_SCORE: 'UCAT/qrScore',
    UCAT_AR_SCORE: 'UCAT/arScore',
    UCAT_TOTAL_COGNITIVE_SUBTEST_SCORE: 'UCAT/totalCognitiveSubtestScore',
    UCAT_SJT_SCORE: 'UCAT/sjtScore',
    UCAT_PERCENTILE: 'UCAT/percentile',
    // GAMSAT
    GAMSAT_SECTION_I_SCORE: 'GAMSAT/sectionIScore',
    GAMSAT_SECTION_II_SCORE: 'GAMSAT/sectionIIScore',
    GAMSAT_SECTION_III_SCORE: 'GAMSAT/sectionIIIScore',
    GAMSAT_OVERALL_SCORE: 'GAMSAT/overallScore',
    GAMSAT_PERCENTILE: 'GAMSAT/percentile',
    // QCE
    QCE_IA_1_NUMERICAL_SCORE: 'QCE/ia1NumericalScore',
    QCE_IA_1_GRADE: 'QCE/ia1Grade',
    QCE_IA_2_NUMERICAL_SCORE: 'QCE/ia2NumericalScore',
    QCE_IA_2_GRADE: 'QCE/ia2Grade',
    QCE_IA_3_NUMERICAL_SCORE: 'QCE/ia3NumericalScore',
    QCE_IA_3_GRADE: 'QCE/ia3Grade',
    QCE_EA_1_NUMERICAL_SCORE: 'QCE/ea1NumericalScore',
    QCE_EA_1_GRADE: 'QCE/ea1Grade',
    QCE_OVERALL_NUMERICAL_SCORE: 'QCE/overallNumericalScore',
    QCE_OVERALL_GRADE: 'QCE/overallGrade',
    // WACE
    WACE_SCHOOL_MARK_NUMERICAL: 'WACE/schoolMarkNumerical',
    WACE_SCHOOL_MARK_GRADE: 'WACE/schoolMarkGrade',
    WACE_EXAM_MARK_NUMERICAL: 'WACE/examMarkNumerical',
    WACE_EXAM_GRADE: 'WACE/examGrade',
    WACE_COMBINED_SCORE: 'WACE/combinedScore',
    // SACE
    SACE_IA_GRADE: 'SACE/iaGrade',
    SACE_EA_GRADE: 'SACE/eaGrade',
    SACE_FINAL_GRADE: 'SACE/finalGrade',
    // CELS191
    CELS191_PROGRESS_TEST_MARK: 'CELS191/progressTestMark',
    CELS191_FINAL_MARK: 'CELS191/finalMark',
    // CHEM191
    CHEM191_PROGRESS_TEST_MARK: 'CHEM191/progressTestMark',
    CHEM191_FINAL_MARK: 'CHEM191/finalMark',
    // PHSI191
    PHSI191_PROGRESS_TEST_MARK: 'PHSI191/progressTestMark',
    PHSI191_FINAL_MARK: 'PHSI191/finalMark',
    // BIOC192
    BIOC192_PROGRESS_TEST_MARK: 'BIOC192/progressTestMark',
    BIOC192_FINAL_MARK: 'BIOC192/finalMark',
    // HUBS191
    HUBS191_PROGRESS_TEST_1_MARK: 'HUBS191/progressTest1Mark',
    HUBS191_PROGRESS_TEST_2_MARK: 'HUBS191/progressTest2Mark',
    HUBS191_FINAL_MARK: 'HUBS191/finalMark',
    // HUBS192
    HUBS192_PROGRESS_TEST_1_MARK: 'HUBS192/progressTest1Mark',
    HUBS192_PROGRESS_TEST_2_MARK: 'HUBS192/progressTest2Mark',
    HUBS192_FINAL_MARK: 'HUBS192/finalMark',
    // POPH192
    POPH192_PROGRESS_TEST_1_MARK: 'POPH192/progressTest1Mark',
    POPH192_PROGRESS_TEST_2_MARK: 'POPH192/progressTest2Mark',
    POPH192_FINAL_MARK: 'POPH192/finalMark',
    // Optional 8th Paper
    OPTIONAL_8TH_PAPER_FINAL_MARK: 'OPTIONAL_8TH_PAPER/finalMark',
    // ISAT
    ISAT_CR_SCORE: 'ISAT/crScore',
    ISAT_QR_SCORE: 'ISAT/qrScore',
    ISAT_TOTAL_SCORE: 'ISAT/totalScore',
    ISAT_PERCENTILE: 'ISAT/percentile',
    // BMAT
    BMAT_SECTION_1: 'BMAT/section1',
    BMAT_SECTION_2: 'BMAT/section2',
    BMAT_SECTION_3: 'BMAT/section3',
    // BIOSCI107
    BIOSCI107_TEST_GRADE: 'BIOSCI107/testGrade',
    BIOSCI107_FINAL_GRADE: 'BIOSCI107/finalGrade',
    // CHEM110
    CHEM110_TEST_GRADE: 'CHEM110/testGrade',
    CHEM110_FINAL_GRADE: 'CHEM110/finalGrade',
    // POPLHLTH111
    POPLHLTH111_TEST_GRADE: 'POPLHLTH111/testGrade',
    POPLHLTH111_FINAL_GRADE: 'POPLHLTH111/finalGrade',
    // MEDSCI142
    MEDSCI142_TEST_1_GRADE: 'MEDSCI142/test1Grade',
    MEDSCI142_TEST_2_GRADE: 'MEDSCI142/test2Grade',
    MEDSCI142_FINAL_GRADE: 'MEDSCI142/finalGrade',
    // ATAR
    ATAR: 'ATAR/atar',
    // Auckland Core CPA Paper Overall GPA
    AKL_CCP_OVERALL_GPA: 'AKLCCP/overallGPA',
    // Otago Paper Average (Best 7)
    OTAGO_P_AVG_BEST_7_AVERAGE: 'OTAGO_P_AVG_BEST_7/average',
    // School GPA.
    SCHOOL_GPA: 'SCHOOL_GPA/score',
    GPA_REGION: 'SCHOOL_GPA/region',
    GPA_YEAR: 'SCHOOL_GPA/year',
    // TOEFL PBT
    TOEFL_PBT_OVERALL: 'TOEFL_PBT/overall',
    // Practice SAT
    PRACTICE_SAT_READING_WRITING: 'PRACTICE_SAT/readingWriting',
    PRACTICE_SAT_MATH: 'PRACTICE_SAT/math',
    PRACTICE_SAT_ESSAY: 'PRACTICE_SAT/essay',
    PRACTICE_SAT_OVERALL_SCORE: 'PRACTICE_SAT/overallScore',
    // Practice ACT.
    PRACTICE_ACT_MATH: 'PRACTICE_ACT/math',
    PRACTICE_ACT_SCIENCE: 'PRACTICE_ACT/science',
    PRACTICE_ACT_READING: 'PRACTICE_ACT/reading',
    PRACTICE_ACT_ENGLISH: 'PRACTICE_ACT/english',
    PRACTICE_ACT_WRITING: 'PRACTICE_ACT/writing',
    PRACTICE_ACT_OVERALL_SCORE: 'PRACTICE_ACT/overallScore',
    // Duolingo
    Duolingo: 'Duolingo/score',
    // TSA
    TSA_SECTION_1: 'TSA/section1',
    // SSAT
    SSAT_VERBAL: 'SSAT/verbal',
    SSAT_QUANTITATIVE: 'SSAT/quantitative',
    SSAT_READING: 'SSAT/reading',
    SSAT_TOTAL: 'SSAT/total',
    // ISEE
    ISEE_VERBAL_REASONING: 'ISEE/verbalReasoning',
    ISEE_READING_COMPREHENSION: 'ISEE/readingComprehension',
    ISEE_QUANTITATIVE_REASONING: 'ISEE/quantitativeReasoning',
    ISEE_MATH: 'ISEE/math',
    // PTE
    PTE_LISTENING: 'PTE/listening',
    PTE_SPEAKING: 'PTE/speaking',
    PTE_WRITING: 'PTE/writing',
    PTE_READING: 'PTE/reading',
    PTE_OVERALL: 'PTE/overall',
    // GMAT
    GMAT_VERBAL: 'GMAT/verbal',
    GMAT_REASONING: 'GMAT/reasoning',
    GMAT_QUANTITATIVE: 'GMAT/quantitative',
    GMAT_WRITING: 'GMAT/writing',
    GMAT_TOTAL: 'GMAT/total',
    // GRE
    GRE_VERBAL_REASONING: 'GRE/verbalReasoning',
    GRE_QUANTITATIVE_REASONING: 'GRE/quantitativeReasoning',
    GRE_ANALYTICAL_WRITING: 'GRE/analyticalWriting',
    GRE_TOTAL: 'GRE/total',
    // LSAT
    LSAT_SCORE: 'LSAT/score',
    LSAT_PERCENTILE: 'LSAT/percentile',
    // MCAT
    MCAT_CHEMICAL_AND_PHYSICAL_FOUNDATIONS: 'MCAT/chemicalAndPhysicalFoundations',
    MCAT_BIOLOGICAL_AND_BIOCHEMICAL_FOUNDATIONS: 'MCAT/biologicalAndBiochemicalFoundations',
    MCAT_PHYSIOGILOGICAL_FOUNDATIONS: 'MCAT/physiogilogicalFoundations',
    MCAT_CRITICAL_ANALYSIS_AND_REASONING_SKILLS: 'MCAT/criticalAnalysisAndReasoningSkills',
    MCAT_TOTAL: 'MCAT/total',
    // LNAT
    LNAT_SECTION_A: 'LNAT/sectionA',
};
//# sourceMappingURL=gradeResultType.js.map